/*
 * Conditions EVO
 * Author: Moncef
 * ------
 * Todo:
 * - Lire toutes les conditions à l'initialization et assigné des id's a chacune
 * - Rajouter les hooks
 */

import lpApp from '../app/lp_app';
import JsonLogicParser from './jsonlogic/parser';
import JsonLogicApplier from './jsonlogic/applier';

class _ConditionsEvo {
  constructor() {
    this.compiledConditionsList = {};
    this.parsedCompiledConditionsList = {};
    this.hooks = {
      options: {},
      variables: {}
    };
    this.multiples = {};
    this.repeated_dependecies = {};
    this.initiated = false;

    this.conditions = {};

    this.repeated_options = [];

    this.parents_tree = {
      options: {},
      variables: {}
    };
  }

  init() {
    // Initializing conditions
    this.initializeCompiledConditions();
    this.initializeHooks();
    this.initializeMultiples();
    this.initializeParentTree();
    this.parseCompiledConditions();

    this.initiated = true;
  }

  execAllConditions(){
    // Getting list of ids from the complied conditions object
    let conditionsIds = Object.keys(this.compiledConditionsList);

    // Adding the list of ids from the conditions object (in order to add multiples)
    Object.keys(this.conditions).forEach(id => {
      if(!conditionsIds.includes(id))
        conditionsIds.push(id);
    });

    // Executing all conditions
    conditionsIds.forEach(id => {
      this.execCondition(id);
    }, this);
  }

  /**
   *  INITIALIZERS BEGIN
   */

  // Initializes the compiledConditions object
  initializeCompiledConditions() {
    Object.keys(lpApp.references.options).map((id) => {
      let option = lpApp.references.getOption(id);
      if (option.meta.conditional) {
        let compiledConditions = option.meta.compiledConditions;
        if (typeof (compiledConditions) == 'object' && compiledConditions.length > 0)
          this.compiledConditionsList[id] = [...compiledConditions];
      }

      if (option.meta.multiple)
        this.multiples[id] = false;

      if (option.meta.multiple || option.meta.parentMultiple)
        this.repeated_options.push(parseInt(id));

      if (option.meta.type == 'repeated') {
        let repeat_id = option.meta.repeatOption;

        if (!this.repeated_dependecies[repeat_id])
          this.repeated_dependecies[repeat_id] = [];
        let children = lpApp.ops.utils.getAllChildren(id);

        this.repeated_options = [...this.repeated_options, parseInt(id), ...children];

        this.repeated_dependecies[repeat_id] = [...this.repeated_dependecies[repeat_id], parseInt(id), ...children];
      }

      return option;
    }, this);
  }

  // Parses all compiled conditions to JsonLogic
  parseCompiledConditions() {
    Object.keys(this.compiledConditionsList).map((id) => {
      try {
        this.parsedCompiledConditionsList[id] = new JsonLogicParser(this.compiledConditionsList[id]);
      } catch(e) {
        console.error(e);
      }
    }, this);
  }

  // Intializes the hooks
  initializeHooks() {

    let pushHook = (idx, id) => {
      if ('c' in idx) {
        if (!idx.v) {
          if (!this.hooks.options[idx.o])
            this.hooks.options[idx.o] = [];
          this.hooks.options[idx.o].push(id);
        } else {
          if (!this.hooks.variables[idx.v])
            this.hooks.variables[idx.v] = [];
          this.hooks.variables[idx.v].push(id);
        }
      } else if ('condition_array' in idx) {
        idx.condition_array.map((idx) => {
          pushHook(idx, id);
        });
      }
    };

    Object.keys(this.compiledConditionsList).map((id) => {
      let _c = this.compiledConditionsList[id];
      _c.map((idx) => {
        pushHook(idx, id);
      });
    }, this);

    /*
     * Reverse dependencies
     */
    Object.keys(this.hooks.options).map((id) => {
      let parents_tree = [];

      let parent = lpApp.indexes.grandpa.getFather(id);
      if (parent) parents_tree.push(parent);
      while (typeof parent != 'undefined') {
        parent = lpApp.indexes.grandpa.getFather(parent);
        if (parent) parents_tree.push(parent);
      }

      parents_tree.map((parent_id) => {
        if (this.compiledConditionsList[parent_id]) {
          if (!this.hooks.options[parent_id])
            this.hooks.options[parent_id] = [];
          this.hooks.options[parent_id] = [...this.hooks.options[parent_id], ...this.hooks.options[id]];
        }
      });
    });
  }

  // Intializes the multiples
  initializeMultiples() {
    Object.keys(this.multiples).map((id) => {
      // Getting all children
      let options = lpApp.ops.utils.getAllChildren(id);
      let variables = lpApp.ops.utils.getAllVariableChildren([id, ...options]);
      let compiledConditionsList = [];
      let hooks = {
        options: [],
        variables: []
      };
      options.map((cid) => {
        if (Object.keys(this.compiledConditionsList).includes(cid.toString()))
          compiledConditionsList.push(cid);
        if (Object.keys(this.hooks.options).includes(cid.toString()))
          hooks.options.push(parseInt(cid));
      }, this);
      variables.map((vid) => {
        if (Object.keys(this.hooks.variables).includes(vid.toString()))
          hooks.variables.push(parseInt(vid));
      }, this);

      if(this.hooks.options.hasOwnProperty(id.toString()))
        hooks.options = [...hooks.options, ...this.hooks.options[id].map((v) => parseInt(v))]

        if(this.hooks.variables.hasOwnProperty(id.toString()))
          hooks.variables = [...hooks.variables, ...this.hooks.variables[id].map((v) => parseInt(v))]
      
      if (compiledConditionsList.length == 0 && hooks.options.length == 0 && hooks.variables.length == 0)
        return;

      // Repeat dependencies
      if (this.repeated_dependecies[id])
        options = [...options, ...this.repeated_dependecies[id]];

      this.multiples[id] = {
        descendants: {
          options: options,
          variables: variables
        },
        copies: [],
        compiledConditionsList: compiledConditionsList,
        hooks: hooks
      };

    }, this);

    for (let id in this.multiples) {
      if (typeof this.multiples[id] != 'object') {
        delete this.multiples[id];
      }
    }
  }

  // Initializes parent trees for all our options
  initializeParentTree() {
    Object.keys(this.hooks.options).map((id) => {
      let parents_tree = [];

      let parent = lpApp.indexes.grandpa.getFather(id);
      if (parent) parents_tree.push(parent);
      while (typeof parent != 'undefined') {
        parent = lpApp.indexes.grandpa.getFather(parent);
        if (parent) parents_tree.push(parent);
      }

      this.parents_tree.options[id] = parents_tree;
    });

    Object.keys(this.hooks.variables).map((id) => {
      let parents_tree = [];

      let parent = lpApp.indexes.grandpa_vars.getVGrandpa(id);
      if (parent) parents_tree.push(parent);
      while (typeof parent != 'undefined') {
        parent = lpApp.indexes.grandpa.getFather(parent);
        if (parent) parents_tree.push(parent);
      }

      this.parents_tree.variables[id] = parents_tree;
    });
  }

  /**
   * INITIALIZERS END
   */

  /**
   * MULTIPLES MANAGEMENT BEGIN
   */
  setupMultipleWatchers(a, id) {
    // Waiting for initiation
    if(!this.initiated)
        setTimeout(() => {this.setupMultipleWatchers.apply(this, [a,id])}, 300);

    if (!this.multiples[id])
      return;

    let _this = this; // Must use this here since we can't override Array's this
    a.push = function () {
      Array.prototype.push.apply(this, arguments);
      _this.multipleChangeReduce(id, [...this]);
      return this;
    };

    a.splice = function () {
      Array.prototype.splice.apply(this, arguments);
      _this.multipleChangeReduce(id, [...this]);
      return this;
    };

    a.split = function () {
      Array.prototype.split.apply(this, arguments);
      _this.multipleChangeReduce(id, [...this]);
      return this;
    };
  }

  multipleChangeReduce(id, _new) {
    if (!this.multiples[id])
      return;

    let toAdd = [];
    let toDelete = [];

    // Old copies
    let _old = [...this.multiples[id].copies];


    if (typeof _new != 'object' && typeof _old == 'object') {
      toDelete = _old;
    } else {
      _new.map((copy) => {
        if (!_old.includes(copy))
          toAdd.push(copy);
      });
      _old.map((copy) => {
        if (!_new.includes(copy))
          toDelete.push(copy);
      });
    }

    toAdd.map((copy) => this.addMultiple(id, copy), this);
    toDelete.map((copy) => this.delMultiple(id, copy), this);
  }

  addMultiple(id, copy) {
    if (!this.multiples[id])
      return;

    // Adding parent himself
    if (Object.keys(this.hooks.options).includes(id.toString())) {
      this.hooks.options[id + '_' + copy] = this.hooks.options[id].map((hook_id) => {
        if (this.multiples[id].descendants.options.includes(parseInt(hook_id))) {
          this.execCondition(hook_id, copy);
          hook_id += '_' + copy;
        }
        return hook_id;
      }, this);
    }
    // Adding children
    this.multiples[id].hooks.options.map((child_id) => {
      if(typeof(this.hooks.options[child_id]) === 'undefined')
        return;
      this.hooks.options[child_id + '_' + copy] = this.hooks.options[child_id].map((hook_id) => {
        if (this.multiples[id].descendants.options.includes(parseInt(hook_id))) {
          this.execCondition(hook_id, copy);
          hook_id += '_' + copy;
        }
        return hook_id;
      }, this);
    });

    // Adding variables
    this.multiples[id].hooks.variables.map((variable_id) => {
      if(typeof(this.hooks.variables[variable_id]) === 'undefined')
        return;
      this.hooks.variables[variable_id + '_' + copy] = this.hooks.variables[variable_id].map((hook_id) => {
        if (this.multiples[id].descendants.options.includes(parseInt(hook_id))) {
          this.execCondition(hook_id, copy);
          hook_id += '_' + copy;
        }
        return hook_id;
      }, this);
    });

    // Adding copy
    this.multiples[id].copies.push(copy);

    // Checking if is conditional
    if (Object.keys(this.compiledConditionsList).includes(id.toString())) {
      this.execCondition(id, copy);

      // Adding hooks
      Object.keys(this.hooks.options).map(ho_id => {
        if (this.hooks.options[ho_id].includes(id.toString()))
          this.hooks.options[ho_id].push(id + '_' + copy);
      });
      Object.keys(this.hooks.variables).map(ho_id => {
        if (this.hooks.variables[ho_id].includes(id.toString()))
          this.hooks.variables[ho_id].push(id + '_' + copy);
      });
    }

    // Executing related conditions
    this.multiples[id].compiledConditionsList.map(id => {
      this.execCondition(id, copy);
    });

    // Triggering related conditions
    this.execOptionHook(id);
  }

  delMultiple(id, copy) {
    if (!this.multiples[id])
      return;

    // Adding parent himself
    if (Object.keys(this.hooks.options).includes(id.toString())) {
      delete this.hooks.options[id + '_' + copy];
    }
    // Adding children
    this.multiples[id].hooks.options.map((child_id) => {
      delete this.hooks.options[child_id + '_' + copy];
    });

    // Adding variables
    this.multiples[id].hooks.variables.map((variable_id) => {
      delete this.hooks.variables[variable_id + '_' + copy];
    });

    // Deleting copy
    let copy_index = this.multiples[id].copies.indexOf(copy);
    if (copy_index > -1)
      this.multiples[id].copies.splice(copy_index, 1);

    // Deleting hooks
    Object.keys(this.hooks.options).map(ho_id => {
      if (this.hooks.options[ho_id].includes(id + '_' + copy))
        this.hooks.options[ho_id].splice(this.hooks.options[ho_id].indexOf(id + '_' + copy), 1);
    });
    Object.keys(this.hooks.variables).map(ho_id => {
      if (this.hooks.variables[ho_id].includes(id + '_' + copy))
        this.hooks.variables[ho_id].splice(this.hooks.variables[ho_id].indexOf(id + '_' + copy), 1);
    });

    // Triggering related conditions
    this.execOptionHook(id);
  }

  /**
   * MULTIPLES MANAGEMENT END
   */


  /**
   * CONDITIONS TREATEMENT
   */
  execCondition(id, copy = false) {
    // Separating id and copy if we recieve it attached "id_copy"
    if (typeof id === 'string') {
      let parts = id.split('_');
      if (parts.length > 1) {
        id = parseInt(parts[0]);
        copy = parts[1];
      }
    }

    // Making sur option is conditionned before going any futher
    if (!(id in this.parsedCompiledConditionsList))
      return true;

    // Getting copy
    let _copy = copy === false ? (this.repeated_options.includes(parseInt(id))) ? copy : false : copy;

    // Initiating Applier
    let jl_condition = new JsonLogicApplier(this.parsedCompiledConditionsList[id], _copy, id);

    // Executing condition
    let result = jl_condition.apply();

    // Ref
    let ref = copy !== false ? id + '_' + copy : id;

    // Updating condition
    this.updateCondition(ref, result);

    return result;
  }

  updateCondition(id, result) {
    if (this.conditions[id] == result)
      return;
    this.conditions[id] = result;
  }

  getCondition(id) {
    return typeof this.conditions[id] != 'undefined' ? this.conditions[id] : this.execCondition(id);
  }

  rawCondition(condition, copy = false, id = false) {
    try {
      let parsed_condition = new JsonLogicParser(condition);

      // Initiating Applier
      let jl_condition = new JsonLogicApplier(parsed_condition, copy, id);
      return jl_condition.apply();    
        } catch(e) {
      console.error(e);
    }
   
  }

  /**
   * HOOKS EXECUTION
   */
  execOptionHook(id) {
    if (!this.hooks.options[id])
      return;

    this.hooks.options[id].map((id) => {
      let rest = this.execCondition(id);
      this.execOptionHook(id);
    }, this);
  }

  execVariableHook(id) {
    if (!this.hooks.variables[id])
      return;

    this.hooks.variables[id].map((id) => {
      this.execCondition(id);
    }, this);
  }
}

let ConditionsEvo = new _ConditionsEvo();
export default ConditionsEvo;


// WEBPACK FOOTER //
// ./src/logic/condition_evo.js